import {
  SEARCH,
  SELECT_TAB,
  CLEAR_FILTER,
  TRACK_AND_TRACE,
  UPDATE_SELECTED_CATEGORY_FILTERS,
} from '../actions/types/DashboardActionTypes';
import { AUTH_LOGOUT } from '../../../../components/application/redux/actions/types/authActionTypes';

export const initialState = {
  keyword: '',
  activeTab: '',
  atatId: '',
  selectedCategoryFilters: [],
};

const handleSearch = (action, state) => ({
  ...state,
  keyword: action.keyword,
});

const handleTrackAndTrace = (action, state) => ({
  ...state,
  atatId: action.atatId,
});

const handleSelectTab = (action, state) => ({
  ...state,
  activeTab: action.activeTab,
});

const handleClearFilter = (action, state) => ({
  ...state,
  keyword: action.keyword,
  selectedCategoryFilters: action.selectedCategoryFilters,
});

const handleUpdateSelectedCategoryFilters = (action, state) => ({
  ...state,
  selectedCategoryFilters: action.selectedCategoryFilters,
});

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRACK_AND_TRACE:
      return handleTrackAndTrace(action, state);
    case SEARCH:
      return handleSearch(action, state);
    case SELECT_TAB:
      return handleSelectTab(action, state);
    case CLEAR_FILTER:
      return handleClearFilter(action, state);
    case UPDATE_SELECTED_CATEGORY_FILTERS:
      return handleUpdateSelectedCategoryFilters(action, state);
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default dashboardReducer;
